var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"raffle-page pb-20",attrs:{"role":"main"}},[_c('div',{staticClass:"raffle-page__container"},[_c('MitmachenForm',{attrs:{"code-error":_vm.codeError,"code-length":60,"code-validation":"bail|required|min:2,length"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }